module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_29-83a82156ea3f7c196f940328f44b91b0.png";